{
  "sitemaps": {
    "title": "Sitemaps",
    "page_content": "Sitemaps allow you to integrate detailed CAD drawings of venues/locations into the map. You can add and manage sitemaps and CAD drawings below.",
    "no_sitemaps_title": "It's a bit empty here...",
    "no_sitemaps_body_1": "There are currently no key locations or sitemaps! Click the ",
    "no_sitemaps_body_2": " button to add as many locations as you want",
    "add_sitemap": "Add Sitemap",
    "create_sitemap_comming_soon_message": "Self upload of CAD drawings is coming soon. In the meantime, our support team can upload your CADs for you.",
    "click_to_open_sitemap_options": "Click to open sitemap options",
    "edit_sitemap": "Edit sitemap",
    "delete_sitemap": "Delete sitemap"
  },
  "user_settings": "User settings",
  "help": "Help",
  "help_menu": {
    "title": "Help and resources",
    "getting_started": "Getting started with Iventis",
    "knowledge_base": "Iventis knowledge base",
    "support": "Support",
    "about": "About Iventis"
  },
  "sso": {
    "title": "SSO Configuration",
    "page_content": "Here you can edit the SSO config for the project",
    "response_signing_certificate": "Response signing certificate",
    "meta_data_location": "Identity Provider Metadata URL",
    "identity_provider": "Identity Provider Entity ID",
    "saved": "SSO configuration saved successfully",
    "setup_description": "When setting up SSO with your identity provider, you will need to select SAML and enter the following properties",
    "entity_id": "Entity Id",
    "rely_url": "Reply URL",
    "signon_url": "SignOn URL",
    "sso_enabled": "SSO enabled",
    "enable_confirmation": "Are you sure you want to enable SSO for this project?",
    "enable_confirmation_warning": "Ensure SSO is properly configured before enabling it to avoid locking users out of the project",
    "disable_confirmation": "Are you sure you want to disable SSO for this project?",
    "disable_confirmation_warning": "Disabling SSO will require all users who currently rely on SSO to set a password. They will receive an email with instructions to create their password to maintain access to the project.",
    "disable_confirmation_warning2": "Once SSO is disabled, re-enabling it will require manually reactivating SSO access for each user."
  },
  "projectCustomisation": {
    "projectNameWarning": "Changing the project name will change the following:",
    "projectNameWarningSsoKey": "Sso:",
    "projectNameWarningSsoValue": "Configuration urls (if enabled)",
    "projectNameWarningUrlKey": "Project Url:"
  },
  "projectRolePermissions": {
    "projectAdministratorsSubMenu": "Project Administrators",
    "projectAdministratorsTitle": "Project administrators",
    "projectAdminRoleDescription": "Here you can add or remove project administrators. These users have access to and can edit all project data, settings and permissions.",
    "addAdmin": "Add user",
    "addProjectAdmin": "Add project admin",
    "removeAdmin": "Remove admin status",
    "removeAdminConfirm": "This person will no longer be a project admin. Do you wish to continue?",
    "removeYourselfAdminConfirm": "You will lose project admin access and wont be able to re-add it. Do you wish to continue?",
    "projectAdminsSelectedConfirmButton": "Add selected",
    "addAdminsToast": "Admins added successfully",
    "removeAdminToast": "Admin removed successfully"
  }
}